import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Spinner,
  Button,
  Row,
  Col,
  Form,
  Toast,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import SmartPagination from "../../Report/EmailCampaignRunReport/DynamicSmartPagination";
import { SmartConnectFetchDidsFromAgentAssignmentDid } from "../../../store/slices/smartConnect/smartConnectDids";
import { ICONS } from "../../../constants/icons";
import { toast } from "react-toastify";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { didAssignmentListStoreFiltersAndAgentGroup } from "../../../store/slices/smartConnect/dynamicAgentGroup";

const LIMIT = 10;
const today = new Date().toISOString().split("T")[0];

function DynamicAgentGroupDidAssignmentList() {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  console.log("location state : ", location.state);
  const [page, setPage] = useState(() => location.state?.page || 1);
  const [agentGroupInfo, setAgentGroupInfo] = useState(location.state);
  const { group_id } = useParams();
  const { didAssignmentList } = useSelector(
    (store) => store.dynamicAgentGroupReducer,
  );
  const { filters: didAssignmentListFilters = {}, currentGroup = {} } =
    didAssignmentList;

  const [filters, setFilters] = useState(
    () =>
      didAssignmentListFilters || {
        agent_name: location.state?.filters?.agent_name ?? "",
        cq_agent_id: location.state?.filters?.cq_agent_id ?? "",
        smart_connect_agent_id:
          location.state?.filters?.smart_connect_agent_id ?? "",
        assign_date: location.state?.filters?.assign_date ?? today,
        did_number: location.state?.filters?.did_number ?? "",
      },
  );

  useEffect(() => {
    setFilters(didAssignmentListFilters);
    console.log("didAssignmentListFilters : ", didAssignmentListFilters);
  }, [didAssignmentListFilters]);

  useEffect(() => {
    setAgentGroupInfo(location.state);
    setPage(1);
    fetchData(1, {
      status: "active",
      agent_type: "DYNAMIC_GROUP",
      agent_group_id:
        location?.state?.groupId || group_id || agentGroupInfo?.groupId,
    });
    console.log("this is triggered.....", group_id, location.state.groupId);
  }, [location.state]);

  useEffect(() => {
    setPage(1);
    fetchData(1, {
      status: "active",
      agent_type: "DYNAMIC_GROUP",
      agent_group_id:
        location?.state?.groupId || group_id || agentGroupInfo?.groupId,
    });
  }, [location.state]);

  const { agentAssignment } = useSelector(
    (state) => state.smartConnectDIDsReducer,
  );

  const { data = [], loading, pagination = {} } = agentAssignment;

  const isToday = (dateStr) => {
    if (!dateStr) return false;

    const today = new Date();
    const inputDate = new Date(dateStr);

    return (
      today.getDate() === inputDate.getDate() &&
      today.getMonth() === inputDate.getMonth() &&
      today.getFullYear() === inputDate.getFullYear()
    );
  };

  const fetchData = async (pageNo = 1, overrideFilters) => {
    try {
      const isAssignDateToday = isToday(filters.assign_date);
      await dispatch(
        SmartConnectFetchDidsFromAgentAssignmentDid({
          limit: LIMIT,
          skip: (pageNo - 1) * LIMIT,
          filters: overrideFilters || {
            agent_name: filters.agent_name || undefined,
            cq_agent_id: filters.cq_agent_id || undefined,
            smart_connect_agent_id: filters.smart_connect_agent_id || undefined,
            status: "active",
            agent_type: "DYNAMIC_GROUP",
            agent_group_id: group_id || agentGroupInfo?.groupId,
            did_number: filters?.did_number,
            // assign_date: filters.assign_date || undefined,
          },
        }),
      ).unwrap();
    } catch (err) {
      console.log("Error in fetchData : ", err);
      const msg =
        typeof err === "string"
          ? err
          : err.message || "Something went wrong. Please Try again later.";
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchData(page);
  }, [page]);

  const handleFilter = () => {
    setPage(1);
    fetchData(1);

    dispatch(didAssignmentListStoreFiltersAndAgentGroup({ filters }));
  };

  const handleReset = () => {
    setFilters({
      agent_name: "",
      cq_agent_id: "",
      smart_connect_agent_id: "",
      assign_date: today,
      status: "ACTIVE",
      agent_type: "DYNAMIC_GROUP",
      agent_group_id: group_id || agentGroupInfo?.groupId,
      did_number: "",
    });

    setPage(1);

    fetchData(1, {
      status: "ACTIVE",
      agent_type: "DYNAMIC_GROUP",
      agent_group_id: group_id || agentGroupInfo?.groupId,
    });

    dispatch(didAssignmentListStoreFiltersAndAgentGroup({ filters }));
  };

  const handleViewDids = (did) => {
    if (!did?.cq_agent_id || !did?.agent_type) {
      toast.error("Invalid agent data");
      return;
    }

    navigation("view-dids", {
      state: {
        cq_agent_id: did.cq_agent_id,
        smart_connect_agent_id: did.smart_connect_agent_id,
        agent_type: did.agent_type,
        agent_name: did.agent_name,
        assign_date: filters.assign_date,
        filters, //filters save
        page,
      },
    });

    dispatch(didAssignmentListStoreFiltersAndAgentGroup({ filters: filters }));
  };

  const showValue = (value) => value ?? "-";

  return (
    <div>
      <h5 className="mb-3 fw-semibold">
        Active DID Assigned to{" "}
        <span className="fw-bold">{agentGroupInfo.groupName}</span> Agents
      </h5>

      {/* Filters */}
      <Card className="mb-3 shadow-sm">
        <Card.Body>
          <Row className="g-2 align-items-end">
            <Col md={3}>
              <Form.Label className="small text-muted">Agent Name</Form.Label>
              <Form.Control
                placeholder="Enter Agent Name"
                value={filters.agent_name}
                onChange={(e) =>
                  setFilters({ ...filters, agent_name: e.target.value })
                }
              />
            </Col>

            <Col md={3}>
              <Form.Label className="small text-muted">CQ Agent ID</Form.Label>
              <Form.Control
                placeholder="Enter CQ Agent ID"
                value={filters.cq_agent_id}
                onChange={(e) =>
                  setFilters({ ...filters, cq_agent_id: e.target.value })
                }
              />
            </Col>

            <Col md={3}>
              <Form.Label className="small text-muted">
                Smart Connect Agent ID
              </Form.Label>
              <Form.Control
                placeholder="Enter Smart Connect ID"
                value={filters.smart_connect_agent_id}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    smart_connect_agent_id: e.target.value,
                  })
                }
              />
            </Col>

            <Col md={3}>
              <Form.Label className="small text-muted">
                Did Number
              </Form.Label>
              <Form.Control
                placeholder="Enter Valid Did Number"
                value={filters.did_number}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    did_number: e.target.value,
                  })
                }
              />
            </Col>

            {/* <Col md={3}>
                            <Form.Label className="small text-muted">Assign Date</Form.Label>
                            <Form.Control
                                type="date"
                                max={new Date().toISOString().split("T")[0]}
                                value={filters.assign_date}
                                onChange={(e) =>
                                    setFilters({ ...filters, assign_date: e.target.value })
                                }
                            />
                        </Col> */}
          </Row>

          <div className="mt-3 d-flex gap-2">
            <Button size="sm" onClick={handleFilter}>
              Apply Filters
            </Button>
            <Button size="sm" variant="outline-secondary" onClick={handleReset}>
              Reset
            </Button>
          </div>
        </Card.Body>
      </Card>

      {/* Table */}
      <Card className="shadow-sm">
        <Card.Body className="p-0">
          <Table bordered hover responsive className="mb-0">
            <thead className="table-light">
              <tr className="text-nowrap">
                <th>#</th>
                <th>Agent Name</th>
                <th>Smart Connect ID</th>
                <th>CQ Agent ID</th>
                <th>DID Count</th>
                {/* <th>Assign Date</th> */}
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="text-center py-4">
                    <Spinner size="sm" />
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">
                    No Active DIDs found
                  </td>
                </tr>
              ) : (
                data.map((did, index) => (
                  <tr key={did.id || index}>
                    <td>{(page - 1) * LIMIT + index + 1}</td>
                    <td>{showValue(did.agent_name)}</td>
                    <td>
                      {showValue(
                        did.smart_connect_agent_id || did.smart_connect_id,
                      )}
                    </td>
                    <td>{showValue(did.cq_agent_id)}</td>
                    <td className="fw-medium">
                      {showValue(did.total_did_assigned)}
                    </td>
                    {/* <td>
                                            {did.assigned_at
                                                ? new Date(did.assigned_at).toLocaleString("en-IN", {
                                                    timeZone: "Asia/Kolkata",
                                                })
                                                : "-"}
                                        </td> */}
                    <td className="text-center">
                      <Button
                        variant="link"
                        className="p-0"
                        title="Spam DID"
                        onClick={() => handleViewDids(did)}
                      >
                        <img
                          src={ICONS.view_action}
                          alt="Delete"
                          style={{ width: 25, opacity: 0.8 }}
                        />
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {pagination?.totalPages > 1 && (
            <div className="p-3">
              <SmartPagination
                currentPage={page}
                totalPages={pagination.totalPages}
                onPageChange={setPage}
              />
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}

export default DynamicAgentGroupDidAssignmentList;
